import { CacheableContractInteractionsLoader, DebuggableExecutorFactory, MemBlockHeightSwCache, SmartWeave } from '..';
export class SmartWeaveBuilder {
    constructor(_arweave) {
        this._arweave = _arweave;
    }
    setDefinitionLoader(value) {
        this._definitionLoader = value;
        return this;
    }
    setInteractionsLoader(value) {
        this._interactionsLoader = value;
        return this;
    }
    setCacheableInteractionsLoader(value, maxStoredInMemoryBlockHeights = 1) {
        this._interactionsLoader = new CacheableContractInteractionsLoader(value, new MemBlockHeightSwCache(maxStoredInMemoryBlockHeights));
        return this;
    }
    setInteractionsSorter(value) {
        this._interactionsSorter = value;
        return this;
    }
    setExecutorFactory(value) {
        this._executorFactory = value;
        return this;
    }
    setStateEvaluator(value) {
        this._stateEvaluator = value;
        return this;
    }
    overwriteSource(sourceCode) {
        if (this._executorFactory == null) {
            throw new Error('Set base ExecutorFactory first');
        }
        this._executorFactory = new DebuggableExecutorFactory(this._executorFactory, sourceCode);
        return this.build();
    }
    build() {
        return new SmartWeave(this._arweave, this._definitionLoader, this._interactionsLoader, this._interactionsSorter, this._executorFactory, this._stateEvaluator);
    }
}
//# sourceMappingURL=SmartWeaveBuilder.js.map